export default [
  {
    component: () => import('../pages/workspace-onboarding-page.vue'),
    name: 'workspace.onboarding',
    path: '/:slug/workspace/onboarding',
  },
  {
    component: () => import('../pages/workspace-general-form.vue'),
    name: 'workspace.settings',
    path: '/:slug/workspace/settings',
  },
  {
    component: () => import('../pages/workspace-investor-settings-form.vue'),
    name: 'workspace.settings.investor',
    path: '/:slug/workspace/settings/investor',
  },
  {
    component: () => import('../pages/workspace-company-settings-form.vue'),
    name: 'workspace.settings.company',
    path: '/:slug/workspace/settings/company',
  },
  {
    component: () => import('../pages/workspace-reminders-form.vue'),
    name: 'workspace.settings.reminders',
    path: '/:slug/workspace/settings/reminders',
  },
  {
    component: () => import('../pages/workspace-email-form.vue'),
    name: 'workspace.settings.emails',
    path: '/:slug/workspace/settings/emails',
  },
  {
    component: () => import('../pages/workspace-delete-form.vue'),
    name: 'workspace.settings.delete',
    path: '/:slug/workspace/settings/delete',
  },
]
